/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Decrease_Playback_SpeedInputs */



/**
* | output |
* | --- |
* | "Decrease Playback Speed" |
*
* @param {Shortcut_Keys_Name_Decrease_Playback_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_decrease_playback_speed = /** @type {((inputs?: Shortcut_Keys_Name_Decrease_Playback_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Decrease_Playback_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer la vitesse de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiedergabegeschwindigkeit verringern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Diminuire la velocità di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Снизить скорость воспроизведения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir la velocidad de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("降低播放速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生速度を下げる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेबैक गति कम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminuir a velocidade de reprodução")
	return /** @type {LocalizedString} */ ("Decrease Playback Speed")
});